import { useState, useContext, useRef } from 'react'
import api from 'utils/api'
import FinalForm from 'components/Form/Final'
import Input from 'components/Form/Input'
import Dropdown from 'components/Form/Dropdown'
import LoadingSendForm from 'components/Loading/SendForm'
import { LoadingContext } from 'context/LoadingContext'
import StatusRepairDetails from 'components/StatusRepairDetails'


function FormStatusRepair({ success }) {
  const [successSend, setSuccessSend] = useState(false),
        [isLoading, setIsLoading] = useContext(LoadingContext),
        [labelChallengeValue, setLabelChallengeValue] = useState('E-mail'),
        [errorOrder, setOrderError] = useState(null),
        [order, setOrder] = useState(null),
        refChallengeValue = useRef();

  const handleSubmit = async (values) => {
    let data = {
      orderId: values.numerZlecenia,
      challengeType: values.challengeType.value,
      challengeValue: values.challengeValue
    }

    setIsLoading(true)
    setOrderError(null)
    return new Promise((resolve, reject) => setTimeout(
      async ()=> {
        try{
          let response = await api().post('order/status', data)
          resolve(response)
        }catch(e){
          setIsLoading(false)
          setOrderError(e.errorMessage)
          reject()
        }
      }, 1000)
    )
  }

  const onSuccess = (res) => {
    setOrder(res.data.data)
    setIsLoading(false)
    setSuccessSend(true)
    success()
  }

  const renderError =() => {
    return (<div style={{width: '100%', textAlign: 'center', color: '#EB5757', position: 'relative', top: '-20px'}}>{errorOrder}</div>)
  }

  const afterChangeChallengeType = ({ value }) => {
    let labelChallengeValue = '';

    switch(value) {
      case 'serialNumber':
        labelChallengeValue = 'Nr seryjny';
      break;
      case 'phoneNumber':
        labelChallengeValue = 'Nr telefonu';
      break;
      default:
        labelChallengeValue = 'E-mail';
      break;
    }

    setLabelChallengeValue(labelChallengeValue);
    refChallengeValue.current.focus();
  }

  const renderForm = () => {
    return (
      <FinalForm 
        schemaValidation={{
          numerZlecenia: 'required',
          challengeType: 'required',
          challengeValue: 'required',
        }}
        handleSubmit={handleSubmit}
        onSuccess={onSuccess}
      >
        {({ form, handleSubmit, submitting, pristine, values, errors, submitErrors, mutators }) => {
          return (
              <div className="check-status">
                <h2 className="status-title">Sprawdź status naprawy</h2>
                <p className="check-status-desc">Dbając o ochronę danych naszych Klientów wymagamy podania numeru seryjnego, adresu e-mail lub numeru telefonu podanego przy rejestracji.</p>
                <LoadingSendForm customClass="status-repair">
                  <div className="row check-status-row">
                    <div className="col-md-6 col-lg-4">
                      <Input
                        label="Numer zlecenia (RMA)"
                        name="numerZlecenia"
                        type="text"
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <Dropdown
                        label="Typ weryfikacji"
                        name="challengeType"
                        options={[
                          { value: 'serialNumber', label: 'Nr seryjny'},
                          { value: 'emailAddress', label: 'Adres e-mail'},
                          { value: 'phoneNumber', label: 'Nr telefonu'}
                        ]}
                        afterChange={afterChangeChallengeType}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <Input
                        label={labelChallengeValue}
                        name="challengeValue"
                        type="text"
                        inputRef={refChallengeValue}
                      />
                    </div>
                  </div>
                </LoadingSendForm>
                { errorOrder && renderError()}
                <button className={"primary-button arrow "+(submitting ? ' disabled' : '')} htmltype="submit">Sprawdź status</button>
              </div>
          )
        }}
      </FinalForm>
    )
  }

  const renderSuccess = () => {
    return (
      <StatusRepairDetails order={order} />
    )
  }

  return (
      !successSend ? renderForm() : renderSuccess()
  )

}

export default FormStatusRepair;
